module.exports = __webpack_public_path__ + "img/SS_Facility_Google-Map-Pin_Pink.53ca4d82.png";